import { Chip } from '@mui/material'
import type { CSSProperties, FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import type { TagInfo } from 'src/components/Tag/useTagInfo'
import MarkdownRenderer from 'src/components/ui/MarkdownRenderer'
import { startEventGroup, track } from 'src/utils/tracker'

const TagDescription: FC<{
  tagInfo: TagInfo
  className?: string
  style?: CSSProperties
}> = ({ tagInfo, className, style }) => {
  const { t } = useTranslation(['common'])

  return (
    <div className={className} style={style}>
      <div className="flex gap-4 items-center flex-wrap">
        {tagInfo.selectedContestTag && (
          <div className="font-bold leading-5">#{tagInfo.name}</div>
        )}

        {tagInfo.selectedContestTag ? (
          tagInfo.selectedContestTag.isInProgress ? (
            <>
              <Chip
                size="small"
                color="error"
                label={t('common:in-progress')}
              />

              <Link
                to={`/generator?challenge=${tagInfo.selectedContestTag?.cid}`}
                onClick={() => {
                  track('contest_join_click')
                  startEventGroup('generate_source')
                }}
              >
                {t('common:click-here-to-join-contest')}
              </Link>
            </>
          ) : tagInfo.selectedContestTag.isEnded ? (
            <Chip size="small" color="default" label={t('common:ended')} />
          ) : null
        ) : null}
      </div>
      {tagInfo.description ? (
        <MarkdownRenderer
          className="prose dark:prose-invert w-full max-w-full [&_img]:m-auto"
          onClick={() => {
            track('animate_learn_click')
          }}
        >
          {tagInfo.description}
        </MarkdownRenderer>
      ) : null}
    </div>
  )
}

export default TagDescription
